import { API_HOST } from 'api/ApiInstance';
// import { usePaymentState } from 'payment_state/PaymentStateContext';
import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation } from 'react-router-dom';

interface SubmitForm {
  [key: string]: string;
}

interface EventData {
  eventType: string;
  data: SubmitForm;
}

const FormSubmit = () => {
  const [submitFormData, setSubmitFormData] = useState<SubmitForm | null>(null);
  const [scheme, setScheme] = useState<string>('');
  const location = useLocation();
  // const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const schemeGroup = urlParams.get('schemeGroup');

    if (schemeGroup) {
      setScheme(schemeGroup);
    }

    if (isMobile) {
      //@ts-ignore
      const form = location.state.formData;
      setSubmitFormData(form);
    } else {
      const receiveMessage = (event: MessageEvent) => {
        if (event.origin !== window.location.origin) {
          // 신뢰할 수 없는 출처에서 온 메시지는 무시합니다.
          return;
        }

        const eventData: EventData = event.data;
        if (eventData.eventType === 'formData') {
          setSubmitFormData(event.data.data);
        }
      };

      window.addEventListener('message', e => {
        receiveMessage(e);
      });

      return () => {
        window.removeEventListener('message', receiveMessage);
      };
    }
  }, [location]);

  useEffect(() => {
    if (submitFormData && scheme) {
      createFormAndSubmit(submitFormData, scheme);
    }
  }, [submitFormData]);

  const createFormAndSubmit = (formData: SubmitForm, scheme: string) => {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', `${API_HOST}/auth/${scheme}`);
    form.style.display = 'none';
    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', key);
      if (
        key === 'cardNumber' ||
        key === 'cardMonth' ||
        key === 'cardYear' ||
        key === 'cardCvv' ||
        key === 'schemeRequiredData'
      ) {
        input.setAttribute('value', JSON.stringify(value));
      } else {
        input.setAttribute('value', String(value));
      }
      form.appendChild(input);
    });

    // 폼이 제출되었을 때 sessionStorage에 상태를 저장합니다.
    sessionStorage.setItem('formSubmitted', 'true');

    document.body.appendChild(form);

    form.submit();
  };

  return null;
};

export default FormSubmit;
